export default "__VITE_ASSET__DT60RkJH__"